import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { to: "/", label: "首页" },
  { to: "/blacklist", label: "避雷名单" },
  { to: "/guides", label: "维权指南" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系与提交线索" },
];

const CATEGORY_LINKS = [
  { to: "/blacklist?category=ecommerce", label: "电商购物" },
  { to: "/blacklist?category=finance", label: "投资理财" },
  { to: "/blacklist?category=parttime", label: "网络兼职" },
  { to: "/blacklist?category=loan", label: "网络贷款" },
  { to: "/blacklist?category=education", label: "教育培训" },
];

const GUIDE_LINKS = [
  { to: "/guides/platform-runaway-evidence", label: "跑路后先固定哪些证据" },
  { to: "/guides/ponzi-warning-signals", label: "识别资金盘的 7 个信号" },
  { to: "/guides/refund-complaint-flow", label: "退款维权完整流程" },
  { to: "/guides/report-channels-list", label: "举报渠道清单" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-primary-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-radar-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">避雷哨</span>
            </Link>
            <p className="mt-4 max-w-xs font-label text-sm leading-relaxed text-primary-200">
              汇总网站黑料、避雷名单、不靠谱平台、诈骗举报与跑路记录，帮助你在付款前多看一眼。
            </p>
            <p className="mt-4 font-label text-xs leading-relaxed text-primary-300">
              本站内容基于用户反馈与公开信息整理，仅供参考，不构成对任何主体的定性结论。
            </p>
          </div>

          <nav aria-label="快速导航">
            <h4 className="font-heading text-base font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {QUICK_LINKS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="font-label text-sm text-primary-200 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="风险类型导航">
            <h4 className="font-heading text-base font-semibold text-background-50">风险类型</h4>
            <ul className="mt-4 space-y-2.5">
              {CATEGORY_LINKS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="font-label text-sm text-primary-200 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="指南导航">
            <h4 className="font-heading text-base font-semibold text-background-50">热门指南</h4>
            <ul className="mt-4 space-y-2.5">
              {GUIDE_LINKS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="font-label text-sm leading-relaxed text-primary-200 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 font-label text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 避雷哨 · 网站黑料风险记录库</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/about" className="transition-colors hover:text-background-50 cursor-pointer">
              免责声明
            </Link>
            <Link to="/contact" className="transition-colors hover:text-background-50 cursor-pointer">
              更正与投诉
            </Link>
            <span>内容仅供参考</span>
          </p>
        </div>
      </div>
    </footer>
  );
}